<template>
  <div
    class="gmfbtn"
    data-tst="gmfbtn-solutions"
  >
    <div
      class="gw_btn weight_500"
      style="padding: 0 0.75rem"
    >
      <slot>
        <span
          class="truncate"
          style="line-height: 1.2; max-width: calc(100vw - 5rem)"
          v-html="gmfHtml"
        ></span>
      </slot>
    </div>
    <div
      v-if="hasCogBtn"
      class="gw_btn csst csst_nm"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
    >
      <i class="mdi mdi-cog text-normal line-height_1"></i>
      <div
        class="csst_content"
        style="position: fixed"
        v-html="$t('tooltips.choose_solution')"
      ></div>
      <slot name="dot"></slot>
    </div>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'GmfSelektorBtn',
  mixins: [float_mix],
  props: {
    gmfHtml: String,
    hasCogBtn: { type: Boolean, default: true },
  },
}
</script>

<style lang="scss" scoped>
.gmfbtn {
  display: flex;
  height: 1.75rem;
  gap: 2px;
  gap: 2px;
}
</style>
